import { render, staticRenderFns } from "./ContratViewer.vue?vue&type=template&id=b61747ee&"
import script from "./ContratViewer.vue?vue&type=script&lang=js&"
export * from "./ContratViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports